
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import PendoIcon from './pendo-icon.js';

var script = {
  name: 'PendoAppCell',
  components: {
    PendoIcon
  },
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    icon() {
      return {
        web: 'monitor',
        extension: 'puzzle-piece',
        ios: 'ios',
        android: 'android'
      }[this.row.app.platform];
    },

    name() {
      return this.row.app.displayName || this.row.app.name;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "pendo-table__app"
  }, [_c('pendo-icon', {
    staticClass: "pendo-table__app-icon",
    attrs: {
      "type": _vm.icon,
      "size": "14"
    }
  }), _vm._v(" "), _c('div', {
    ref: "name",
    staticClass: "pendo-table__app-name"
  }, [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")])], 1);
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-app-cell.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoAppCell = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoAppCell;
